import $ from 'jquery';

if (!window.jQuery || !window.$) {
    window.jQuery = window.$ = $;
}

export default $;